import LogsAlert from './LogsAlert'
export default LogsAlert
